'use client';

//* Styles
import HomeTemplateStyle from './style';

//* Components
import InfiniteScrollAppend from '@/components/InfiniteScrollAppend';

const HomeTemplate = ({ pageData }) => {
	const { portfolio_items } = pageData;

	return (
		<HomeTemplateStyle>
			<InfiniteScrollAppend items={portfolio_items} />
		</HomeTemplateStyle>
	);
};

export default HomeTemplate;
